module.exports = __webpack_public_path__ + "static/media/hero-bg.5f5948cb.png";